import React from "react";
import StepCompleteActionButton from "./StepCompleteActionButton";

const NonCitizenDocumentChooser = ({ onSelect }) => {
    return (
        <>
            <h1 className="text-dark mb-4 fw-semibold">What is your status?</h1>

            <StepCompleteActionButton
                label="Green Card"
                onClick={() =>
                    onSelect({
                        subPhase: "green_card",
                        nextPhase: "camera",
                        reset: true
                    })
                }
            />

            <div className="mt-3" />

            <StepCompleteActionButton
                label="EAD Card"
                onClick={() =>
                    onSelect({
                        subPhase: "ead",
                        nextPhase: "camera",
                        reset: true
                    })
                }
            />
        </>
    );
};

export default NonCitizenDocumentChooser;